import axios from '@/common/http.js';
import { setStoreData,getType } from '@/common/tolls.js'
import store from '@/store/index.js';

var setPageTotal = function(total,store) {
	total && (store.commit("setStoreData",{
		key: ['page_total'],
		data: total
	}));
}
//  格式化文件大小
function renderSize(value){
	if(null==value||value==''){
		return "-";
	}
	let unitArr = new Array("Bytes","KB","MB","GB","TB","PB","EB","ZB","YB");
	let index = 0;
	let srcsize = parseFloat(value);
	index = Math.floor(Math.log(srcsize)/Math.log(1024));
	let size = srcsize/Math.pow(1024,index);
	//  保留的小数位数
	size = size.toFixed(2);
	return size+unitArr[index];
}
// 时间格式转换
function timeConvert(timestamp, num) {
				//num:0 YYYY-MM-DD  num:1  YYYY-MM-DD hh:mm:ss // timestamp:时间戳
				timestamp = timestamp + '';
				timestamp = timestamp.length == 10 ? timestamp * 1000 : timestamp;
				var date = new Date(timestamp);
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				var minute = date.getMinutes();
				var second = date.getSeconds();
				minute = minute < 10 ? ('0' + minute) : minute;
				second = second < 10 ? ('0' + second) : second;
				if (num == 0) {
					return m + '-' + d + ' ' + h + ':' + minute;
				} else if(num == 1){
					return m + '-' + d ;
				}else if(num == 2){
           return d + ' ' + h
        }else {
					return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
				}
			}
function formatDate(date) {
	var date = new Date(parseInt(date)*1000);
	var YY = date.getFullYear() + '-';
	var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
	var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
	return YY + MM + DD +" "+hh + mm;
}			
var actions = {
	async getTrees({ commit, state, getters }) {
		var id = state.chapterid;
		if(!id) {
			return false;
		}
		var request_url = `/index/base/getchapterlist`;
		axios.$req({
			url: `${request_url}?classid=${id}`,
			success({ message }) {
				if(message.length < 1){
					commit("setData",{
						data: 'empty',
						field: 'trees'
					});
					window.localStorage.setItem('Tchapterlist',JSON.stringify('undefined'));
				}else{
					commit("setTrees",{ trees: message });
					window.localStorage.setItem('Tchapterlist',JSON.stringify(message));
				}
			},
			fail(message){
				commit("setData",{
					data: 'err',
					field: 'trees'
				});
			}
		});
	},
	getShareDetail({ commit, state, getters,rootState, dispatch },params) {
		axios.$req({
			url: `index/detail/sdetail`,
			params: params,
			success({ message }) {

				var { address, type, info, list } = message;
				var obj = Object.assign({},state.shareDetail,{
					src: address,
					type: type,//getType(type),
					list,
					info
				});

				commit("setStoreData",{
					key: ['shareDetail'],
					data: obj
				});
			},
			fail() {
			}
		});
		dispatch("getTrees");
	},
	async getResource({ commit, state, getters, rootState }, {prefix = 'getreslist', searchText,page=1,size=5,} = {}) {
		console.log(state,1111)
		var params = {
			chapterid: state.chapterid,
			newtype: state.newtype,
			content: searchText,
			page: page,
			size: size,
			jie : state.jie,
			order: state.selectnavid,
			sort: state.sort,
		};
		if(!params.chapterid || !params.newtype) {
			return false;
		}
		var request_url = `/index/jiaoxue/kongjian/${ prefix }`;
		axios.$req({
			url: `${request_url}`,
			params,
			success({message,message1}) {
				for (let index = 0; index < message.length; index++) {
					message[index].size = renderSize(message[index].size);
				}
				if(message.length < 1){
					commit("setData",{
						data: 'empty',
						field: 'resources'
					});
				}else{
					commit("setData",{
						data: message,
						field: 'resources'
					});
				}
				commit("setStoreData",{
					data: message1,
					key: ['pageTotal']
				});
			},
			fail({ message,message1 }) {
				commit("setData",{
					data: 'err',
					field: 'resources'
				});
				commit("setStoreData",{
					data: 0,
					key: ['pageTotal']
				});
			}
		});
	},

	// getjiaoxueinfo({ commit, state, getters, rootState }, {id ,type ,restype} = {}) {
	// 	var params = {
	// 		id,
	// 		type,
	// 		restype,
	// 	};

	// 	var request_url = `index/detail/jiaoxuedetail`;
	// 	axios.$req({
	// 		url: 	`${request_url}`,
	// 		params,
	// 		success(data) {
	// 			let { message} = data;
	// 			commit("setData",{
	// 				data: message,
	// 				field: 'jiaoxueinfo'
	// 			});
	// 			commit("setStoreData",{
	// 				data: "",
	// 				key: ['error_text']
	// 			});
	// 		},
	// 		fail({ message }) {
	// 			commit("setData",{
	// 				data: [],
	// 				field: 'jiaoxueinfo'
	// 			});
	// 			commit("setStoreData",{
	// 				data: message,
	// 				key: ['error_text']
	// 			});
	// 		}
	// 	});
	// },
  // 获取用户学校
  async getschool({commit, state, getters, rootState }){
	//window.localStorage.setItem('userid','647845');//宋
	//window.localStorage.setItem('userid','653131');//乔
	//let userid = window.localStorage.getItem('userid')//授备课
    let userid = window.localStorage.getItem('userid')//小程序
    let params={
      user_id:userid
    };
    let request_url = `newksapp/taskmanage.Tasklist/teachClass`;
    axios.$req({
      url: `${request_url}`,
      params,
      success(res) {
      if(res.code = '10001'){
        commit("setData",{
        	data: res.data,
        	field: 'schoolArry'
        });
        window.localStorage.setItem('classarr',JSON.stringify(res.data))
      }
      },fail(res) {

			}
    })
  },
  // 获取作业列表
  gettasklist({commit, state, getters, rootState },{classid=0}={}){
    let userid = window.localStorage.getItem('userid')
    let statusindex;
    if(state.statusActive == '全部'){
      statusindex = 0;
    }else{
       statusindex = state.statusidnex;
    }
    let params={
      status:statusindex,
      class_id:classid,
      page:state.zuoyepage,
      psize:state.zuoyepagesize,
      user_id:userid,
      publish_time:state.zuoyesort
    };
    //console.log(params,state.userid)
    let request_url = `newksapp/taskmanage.Tasklist/teachTaskList`;
    axios.$req({
      url: `${request_url}`,
      params,
      success(res) {
       if(res.code = '10001'){
         //console.log(res.data)
        if(res.data.length>0){
          // 多个班级时
         for(let i=0; i<res.data.length; i++){
           let objnums = 0;
           let objovernums = 0;
           let sum_tasks = 0;
            res.data[i].startiem = timeConvert(res.data[i].publish_time,0);
            res.data[i].endtiem = timeConvert(res.data[i].end_time,0);
              res.data[i].objnum = res.data[i].objnum.split(",");
              res.data[i].objovernum = res.data[i].objovernum.split(",");
              res.data[i].sum_mark = res.data[i].sum_mark.split(",");
              for(let j=0; j<res.data[i].objnum.length; j++){
                objnums += Number(res.data[i].objnum[j])
              }
              for(let j=0; j<res.data[i].objovernum.length; j++){
                objovernums += Number(res.data[i].objovernum[j])
              }
              for(let j=0; j<res.data[i].sum_mark.length; j++){
                sum_tasks +=  Number(res.data[i].sum_mark[j])
              }
              res.data[i].objnum = objnums;
              res.data[i].objovernum = objovernums;
              res.data[i].sum_mark = sum_tasks;

         }

         commit("setData",{
         	data: res.data,
         	field: 'zuoyelist'
         });
         commit("setData",{
         	data: res.arr,
         	field: 'zuoyetotal'
         });
         }else{
           commit("setData",{
           	data:'empty',
           	field: 'zuoyelist'
           });
         }
       }else{
           commit("setData",{
           	data:'err',
           	field: 'zuoyelist'
           });
       }
      },fail(res) {


			}
    })
  },
  // 查看班级下作业
  async gettaskclass({commit, state, getters, rootState },{classid,taskid}={}){
    let userid = window.localStorage.getItem('userid')
    let params={
      user_id:userid,
      task_id:taskid,
      class_id:classid,
      page:state.zuoyeSeepage,
      psize:state.zuoyeSeepagesize
    };
    let request_url = `newksapp/taskmanage.Tasklist/taskDetail`;
    axios.$req({
      url: `${request_url}`,
      params,
      success(res) {
         if(res.code = '10001'){
           if(res.data.length>0){
             commit("setData",{
             	data:res.data,
             	field: 'zuoyeSee'
             });
         
             commit("setData",{
             	data: res.arr,
             	field: 'zuoyeSeetotle'
             });
           }else{
             commit("setData",{
             	data:'empty',
             	field: 'zuoyeSee'
             });
           }
         }else{
           commit("setData",{
           	data:'err',
           	field: 'zuoyeSee'
           });
         }
      },fail(res) {
        

  		}
    })
  },
  // 统计    user_id  start  end
  async gettasktongji({commit, state, getters, rootState },{start,end} = {}){
    let userid = window.localStorage.getItem('userid')
    let params={
      user_id:userid,
      start:start,
      end:end,
      sort:state.staticsort
    };
    let request_url = `newksapp/taskmanage.Tasklist/teachClassTongji`;
    axios.$req({
      url: `${request_url}`,
      params,
      success(res) {
         if(res.code = '10001'){
           if(res.data.length>0){
             console.log(res.data)
            for(let i=0; i<res.data.length; i++){
                  res.data[i].sum_good = res.data[i].sum_good.toFixed(2)*100
            //       res.data[i].sum_punctual = (Number(res.data[i].sum_punctual)/Number(res.data[i].sum_count)*100).toFixed(2)
            }
            commit("setData",{
            	data:res.data,
            	field: 'zuoyestatic'
            })
            }else{
              commit("setData",{
              	data:'empty',
              	field: 'zuoyestatic'
              })
            }
         }else{
           commit("setData",{
           	data:'err',
           	field: 'zuoyeSee'
           });
         }
      },fail(res) {
        

  		}
    })
  },
	// 获取考试列表
	async getExamList({commit, state, getters, rootState }){
		let userid = window.localStorage.getItem('userid')
		let params={
			class_id:state.selectclassids,
			page:state.kaoshipage,
			psize:state.kaoshipagesize,
			starttime: state.startimeExamSort,
			userid:userid,
		};	
		if (0 == state.examStatus) {
		}else if(4 == state.examStatus){
			params.judgeover = 1
		}else{
			params.status = state.examStatus;
		}
		let request_url = `newksapp/exammanage.Examlist/newExamList`;
		axios.$req({
			url: `${request_url}`,
			method: 'post',
			params,
			success(res) {
				if(res.code = '10001'){
					if (res.data.length > 0) {		
						for (let i = 0; i < res.data.length; i++) {
							res.data[i].starttime2 = formatDate(res.data[i].starttime);
							res.data[i].endtime2 = formatDate(res.data[i].endtime);									
							if(1 == res.data[i].judgeover){
								res.data[i].status2 = '已阅卷';
							}else if (1 == res.data[i].status) {
								res.data[i].status2 = '未开始';
							}else if(2 == res.data[i].status){
								res.data[i].status2 = '进行中';
							}else{
								res.data[i].status2 = '已结束';
							}
						}
						commit("setData",{
							data: res.data,
							field: 'kaoshilist'
						});
						commit("setData",{
							data: res.arr,
							field: 'kaoshitotal'
						});		
					} else {
						commit("setData",{
							data:'empty',
							field: 'kaoshilist'
						});						
					}
				}else{
					commit("setData",{
						data:'err',
						field: 'kaoshilist'
					});					
				}
			},fail(res) {
				commit("setData",{
					data:'err',
					field: 'kaoshilist'
				});	
			}
		})
	},  
	subjectid({ commit, state, getters,rootState, dispatch },params){
	  ////console.log(params)
	  	commit("setjie",{ id: params });
	},
	substreeInfo({ commit, state, getters,rootState, dispatch },params){
	  // //console.log(params)
	  	commit("substreeInfo",{ id: params });
	},

	getbookinfo({ commit, state, getters, rootState }) {
		var params = {
			classid : state.chapterid,
		};

		var request_url = `index/jiaoxue/kongjian/getbookinfo`;
		axios.$req({
			url: `${request_url}`,
			params,
			success({data, message,message1,message2}) {
				commit("setData",{
					data: message,
					field: 'bookinfo'
				});
				commit("setData",{
					data: message1,
					field: 'bookClassid'
				});
				commit("setData",{
					data: message2,
					field: 'bookPageTotal'
				});
				commit("setStoreData",{
					data: "",
					key: ['error_text']
				});
			},
			fail({data, message,message1,message2}) {
				commit("setData",{
					data: [],
					field: 'bookinfo'
				});
				commit("setData",{
					data: [],
					field: 'bookClassid'
				});
				commit("setData",{
					data: [],
					field: 'bookPageTotal'
				});
				commit("setStoreData",{
					data: message,
					key: ['error_text']
				});
			}
		});
	},

}
export default actions



// WEBPACK FOOTER //
// ./src/store/modules/teaching/action.js